export const buildInvoiceFields = (invoice) => {
  if (!invoice) return []

  return [

    {
      label: "Número de factura",
      value: invoice.invoice_db_ref || "-"
    }
  ]
}